import { render } from "./master.vue?vue&type=template&id=92c8e704"
import script from "./master.vue?vue&type=script&lang=js"
export * from "./master.vue?vue&type=script&lang=js"

import "./master.vue?vue&type=style&index=0&id=92c8e704&lang=scss"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__